export const LOCAL_STORAGE_KEY = {
  ACCESS_TOKEN: "accessToken",
} as const;
